<template>
	<span :title="model">
		<v-autocomplete
			:hint="hint"
			persistent-hint
			v-model="model"
			@input="update()"
			:items="selectItems"
			:disabled="disabled"
			:rules="computedRules"
			:label="label"
			:item-text="itemText"
			:item-value="itemValue"
			clearable
		>
			<template slot="selection" slot-scope="data">
				{{
					!data.item
						? ''
						: !itemText
						? data.item
						: typeof itemText === 'function'
						? itemText(data.item)
						: data.item[itemText]
				}}
			</template>
			<template slot="item" slot-scope="data">
				{{
					!data.item
						? ''
						: !itemText
						? data.item
						: typeof itemText === 'function'
						? itemText(data.item)
						: data.item[itemText]
				}}
			</template>
		</v-autocomplete>
	</span>
</template>

<script>
import BaseInput from './baseInput'
export default {
	extends: BaseInput,
	props: ['values', 'itemText', 'itemValue'],
	computed: {
		selectItems() {
			return typeof this.values === 'function' ? this.values() : this.values
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/baseComponents/inputs/selectInput.vue